import { rest } from 'services'
import { removeFromCartAction } from '../actions'
import { getShoppingData, setFreeAlignmentData } from 'actions/shoppingData'

export const addFreeAlignmentCheckToCart = skuId => dispatch =>
  dispatch(getShoppingData(rest.api.addProductToCart, ({ skuId, quantity: 1 })))
    .then(({ addToQuote }) => {
      const { recentlyAddedSku: [addedService] = []} = addToQuote
      const { commerceItemId } = addedService
      dispatch(setFreeAlignmentData({ commerceItemId, existInOrder: true }))
    })

export const removeFreeAlignmentCheckFromCart = commerceItemId => dispatch =>
  dispatch(removeFromCartAction(commerceItemId))
